// Mock data for product scanning dashboard
export const scanningStats = {
  totalScanned: 1250,
  uniqueEANCount: 450,
  uniqueBrandCount: 85,
  scanThroughput: 120,
};

export const expiryStats = {
  expiredCount: 45,
  nearingExpiryCount: 78,
  complianceRate: 95.5,
  avgTimeToExpiry: "45 days",
  revenueImpact: 25000,
  recentlyExpired: [
    { name: "Amul Milk 500ml", expiredOn: "2023-12-15", ean: "8901234567890" },
    {
      name: "Britannia Good Day",
      expiredOn: "2023-12-14",
      ean: "8901234567891",
    },
    {
      name: "Nestle Maggi 280g",
      expiredOn: "2023-12-14",
      ean: "8901234567892",
    },
    {
      name: "Cadbury Dairy Milk",
      expiredOn: "2023-12-13",
      ean: "8901234567893",
    },
    {
      name: "Parle-G Gold 250g",
      expiredOn: "2023-12-13",
      ean: "8901234567894",
    },
    { name: "Real Juice 1L", expiredOn: "2023-12-12", ean: "8901234567895" },
    {
      name: "MTR Rava Idli Mix",
      expiredOn: "2023-12-12",
      ean: "8901234567896",
    },
    { name: "Kissan Jam 500g", expiredOn: "2023-12-11", ean: "8901234567897" },
    {
      name: "Tropicana Orange 1L",
      expiredOn: "2023-12-11",
      ean: "8901234567898",
    },
    {
      name: "Kellogg's Corn Flakes",
      expiredOn: "2023-12-10",
      ean: "8901234567899",
    },
  ],
  nearingExpiry: [
    {
      name: "Lays Classic 90g",
      expiryDate: "2024-01-15",
      ean: "8901234567900",
    },
    { name: "Dove Soap 100g", expiryDate: "2024-01-14", ean: "8901234567901" },
    {
      name: "Colgate Total 80g",
      expiryDate: "2024-01-14",
      ean: "8901234567902",
    },
    { name: "Surf Excel 1kg", expiryDate: "2024-01-13", ean: "8901234567903" },
    {
      name: "Tata Tea Gold 250g",
      expiryDate: "2024-01-13",
      ean: "8901234567904",
    },
    { name: "Horlicks 500g", expiryDate: "2024-01-12", ean: "8901234567905" },
    { name: "Bournvita 500g", expiryDate: "2024-01-12", ean: "8901234567906" },
    {
      name: "Dettol Soap 125g",
      expiryDate: "2024-01-11",
      ean: "8901234567907",
    },
    { name: "Boost 500g", expiryDate: "2024-01-11", ean: "8901234567908" },
    {
      name: "Lifebuoy Soap 125g",
      expiryDate: "2024-01-10",
      ean: "8901234567909",
    },
  ],
  topExpiringProducts: [
    { brand: "Amul Dairy", count: 15, daysLeft: 5 },
    { brand: "Britannia", count: 12, daysLeft: 7 },
    { brand: "Parle Products", count: 8, daysLeft: 10 },
    { brand: "Nestle India", count: 6, daysLeft: 12 },
    { brand: "ITC Foods", count: 4, daysLeft: 15 }
  ],
};

export const productCategories = {
  categories: [
    { name: "Dairy", count: 250, expiryRisk: "high" },
    { name: "Beverages", count: 180, expiryRisk: "low" },
    { name: "Snacks", count: 320, expiryRisk: "medium" },
  ],
};

export const categoryRiskData = {
  totalCategories: 8,
  riskySummary: {
    high: 3,
    medium: 2,
    low: 3
  },
  categories: [
    { name: "Dairy Products", riskLevel: "high", itemCount: 45, expiryRate: 8.5 },
    { name: "Packaged Foods", riskLevel: "high", itemCount: 38, expiryRate: 7.2 },
    { name: "Beverages", riskLevel: "high", itemCount: 32, expiryRate: 6.8 },
    { name: "Snacks", riskLevel: "medium", itemCount: 28, expiryRate: 4.5 },
    { name: "Personal Care", riskLevel: "medium", itemCount: 25, expiryRate: 3.8 },
    { name: "Household", riskLevel: "low", itemCount: 20, expiryRate: 2.1 },
    { name: "Baby Care", riskLevel: "low", itemCount: 15, expiryRate: 1.8 },
    { name: "Pet Supplies", riskLevel: "low", itemCount: 12, expiryRate: 1.5 }
  ]
};

export const expiryTrendData = {
  // Last 12 months of data
  monthlyTrends: [
    { month: 'Jan 2023', expired: 38, nearExpiry: 65, prevented: 42 },
    { month: 'Feb 2023', expired: 42, nearExpiry: 58, prevented: 45 },
    { month: 'Mar 2023', expired: 35, nearExpiry: 62, prevented: 48 },
    { month: 'Apr 2023', expired: 45, nearExpiry: 70, prevented: 52 },
    { month: 'May 2023', expired: 40, nearExpiry: 55, prevented: 50 },
    { month: 'Jun 2023', expired: 32, nearExpiry: 48, prevented: 55 },
    { month: 'Jul 2023', expired: 28, nearExpiry: 52, prevented: 58 },
    { month: 'Aug 2023', expired: 25, nearExpiry: 45, prevented: 62 },
    { month: 'Sep 2023', expired: 30, nearExpiry: 50, prevented: 60 },
    { month: 'Oct 2023', expired: 35, nearExpiry: 58, prevented: 65 },
    { month: 'Nov 2023', expired: 42, nearExpiry: 62, prevented: 70 },
    { month: 'Dec 2023', expired: 45, nearExpiry: 78, prevented: 75 }
  ],
  categoryTrends: {
    'Dairy Products': [42, 38, 45, 40, 35, 30, 28, 25, 30, 35, 40, 45],
    'Packaged Foods': [35, 32, 38, 42, 38, 35, 30, 28, 32, 35, 38, 42],
    'Beverages': [28, 25, 30, 35, 32, 28, 25, 22, 25, 28, 32, 35],
    'Snacks': [20, 18, 22, 25, 22, 20, 18, 15, 18, 20, 22, 25]
  },
  insights: {
    yearlyTotal: {
      expired: 437,
      nearExpiry: 703,
      prevented: 682
    },
    improvement: {
      sixMonth: 21.4, // % improvement in last 6 months
      yearly: 15.8    // % improvement over the year
    },
    bestMonth: {
      month: 'Aug 2023',
      reduction: 38.2 // % reduction compared to yearly average
    }
  }
};

export const calendarData = {
  summary: {
    upcomingExpiries: "156 products",
    totalEvents: 45,
    criticalDates: ['2023-12-25', '2023-12-28', '2024-01-05']
  },
  events: [
    {
      date: '2023-12-25',
      items: [
        { name: 'Amul Milk 500ml', count: 25, type: 'expired' },
        { name: 'Britannia Bread', count: 15, type: 'nearExpiry' }
      ]
    },
    {
      date: '2023-12-28',
      items: [
        { name: 'Nestle Yogurt', count: 30, type: 'nearExpiry' },
        { name: 'Fresh Juice', count: 10, type: 'expired' }
      ]
    },
    {
      date: '2024-01-05',
      items: [
        { name: 'Dairy Products', count: 45, type: 'warning' },
        { name: 'Packaged Foods', count: 20, type: 'nearExpiry' }
      ]
    },
    {
      date: "2025-01-05",
      items: [
        { name: "Dairy Products", count: 12, type: "nearExpiry" },
        { name: "Fresh Produce", count: 8, type: "expired" }
      ]
    },
    {
      date: "2025-01-12",
      items: [
        { name: "Frozen Foods", count: 15, type: "nearExpiry" }
      ]
    },
    {
      date: "2025-01-18",
      items: [
        { name: "Beverages", count: 20, type: "nearExpiry" },
        { name: "Snacks", count: 5, type: "expired" }
      ]
    },
    {
      date: "2025-01-25",
      items: [
        { name: "Canned Goods", count: 10, type: "nearExpiry" }
      ]
    },
    {
      date: "2025-01-30",
      items: [
        { name: "Bakery Items", count: 18, type: "expired" }
      ]
    },
    {
      date: "2025-02-03",
      items: [
        { name: "Meat Products", count: 8, type: "nearExpiry" },
        { name: "Seafood", count: 6, type: "expired" }
      ]
    },
    {
      date: "2025-02-08",
      items: [
        { name: "Dairy Products", count: 25, type: "nearExpiry" }
      ]
    },
    {
      date: "2025-02-14",
      items: [
        { name: "Chocolates", count: 30, type: "nearExpiry" },
        { name: "Candies", count: 15, type: "expired" }
      ]
    },
    {
      date: "2025-02-20",
      items: [
        { name: "Fresh Produce", count: 22, type: "nearExpiry" }
      ]
    },
    {
      date: "2025-02-27",
      items: [
        { name: "Frozen Foods", count: 12, type: "expired" },
        { name: "Ice Cream", count: 8, type: "nearExpiry" }
      ]
    },
    {
      date: "2025-03-02",
      items: [
        { name: "Beverages", count: 18, type: "nearExpiry" }
      ]
    },
    {
      date: "2025-03-07",
      items: [
        { name: "Snacks", count: 28, type: "nearExpiry" },
        { name: "Chips", count: 14, type: "expired" }
      ]
    },
    {
      date: "2025-03-12",
      items: [
        { name: "Canned Goods", count: 16, type: "nearExpiry" }
      ]
    },
    {
      date: "2025-03-15",
      items: [
        { name: "Bakery Items", count: 20, type: "expired" },
        { name: "Pastries", count: 12, type: "nearExpiry" }
      ]
    },
    {
      date: "2025-03-19",
      items: [
        { name: "Meat Products", count: 15, type: "nearExpiry" }
      ]
    },
    {
      date: "2025-03-22",
      items: [
        { name: "Seafood", count: 10, type: "expired" },
        { name: "Fish", count: 8, type: "nearExpiry" }
      ]
    },
    {
      date: "2025-03-25",
      items: [
        { name: "Dairy Products", count: 30, type: "nearExpiry" }
      ]
    },
    {
      date: "2025-03-28",
      items: [
        { name: "Fresh Produce", count: 25, type: "nearExpiry" },
        { name: "Vegetables", count: 18, type: "expired" }
      ]
    },
    {
      date: "2025-03-30",
      items: [
        { name: "Frozen Foods", count: 22, type: "nearExpiry" }
      ]
    },
    {
      date: "2025-03-31",
      items: [
        { name: "Beverages", count: 16, type: "expired" },
        { name: "Soft Drinks", count: 12, type: "nearExpiry" }
      ]
    }
  ]
};

export const tableViewData = {
  message: "All Data Found!!",
  data: [
    {
      timestamp: "2024-12-20T12:18:42.046Z",
      mrp: 90,
      mfg_date: "27-06-2024",
      expiry_date: "26-06-2027",
      batch_no: "B120624",
      ean: "788821005144",
      expired: false,
      almost_expired: false
    },
    {
      timestamp: "2024-12-20T12:18:26.817Z",
      mrp: 90,
      mfg_date: "22-05-2024",
      expiry_date: "21-05-2027",
      batch_no: "B",
      ean: "788821003140",
      expired: false,
      almost_expired: false
    },
    {
      timestamp: "2024-12-20T12:18:10.919Z",
      mrp: 90,
      mfg_date: "22-05-2024",
      expiry_date: "21-05-2027",
      batch_no: "B4290424",
      ean: "788821030016",
      expired: false,
      almost_expired: false
    },
    {
      timestamp: "2024-12-20T12:17:55.672Z",
      mrp: 90,
      mfg_date: "06-06-2024",
      expiry_date: "05-06-2027",
      batch_no: "B111123",
      ean: "788821007148",
      expired: false,
      almost_expired: false
    },
    {
      timestamp: "2024-12-20T12:17:40.503Z",
      mrp: 68,
      mfg_date: "01-10-2024",
      expiry_date: "01-12-2025",
      batch_no: "E070559221",
      ean: "8901786020508",
      expired: false,
      almost_expired: true
    },
    {
      timestamp: "2024-12-20T12:17:22.831Z",
      mrp: 98,
      mfg_date: "01-10-2024",
      expiry_date: "01-09-2025",
      batch_no: "539",
      ean: "8904053502196",
      expired: false,
      almost_expired: true
    },
    {
      timestamp: "2024-12-20T12:17:05.795Z",
      mrp: 48,
      mfg_date: "01-11-2024",
      expiry_date: "01-10-2025",
      batch_no: "SK08J29",
      ean: "8901662028062",
      expired: false,
      almost_expired: true
    },
    {
      timestamp: "2024-12-20T12:16:49.303Z",
      mrp: 92,
      mfg_date: "01-06-2024",
      expiry_date: "01-12-2025",
      batch_no: "B180562591",
      ean: "8901786151004",
      expired: true,
      almost_expired: false
    },
    {
      timestamp: "2024-12-20T12:16:28.200Z",
      mrp: 52,
      mfg_date: "01-10-2024",
      expiry_date: "01-09-2025",
      batch_no: "SJ20J01",
      ean: "8901662025351",
      expired: true,
      almost_expired: false
    },
    {
      timestamp: "2024-12-20T12:15:44.006Z",
      mrp: 299,
      mfg_date: "01-07-2024",
      expiry_date: "01-06-2025",
      batch_no: "not",
      ean: "8901725112905",
      expired: true,
      almost_expired: false
    }
  ]
};
